export const OrderByValue = {
  ascending: 'asc',
  descending: 'desc'
};

export const TitleOptions = [
  { text: 'NFs/MODAL', canOrder: false },
  { text: 'Organização', canOrder: false },
  { text: 'Veículo', canOrder: false },
  { text: 'Peso', canOrder: true, attribute: "weight" },
  { text: 'Nome origem', canOrder: false },
  { text: 'Local origem', canOrder: false },
  { text: 'Nome destino', canOrder: false },
  { text: 'Local destino', canOrder: false },
  { text: 'Distância estado', canOrder: false },
  { text: 'Emissão CO2', canOrder: false },
];
